module.exports = __webpack_public_path__ + "img/antlers_tok.waxdeers.4d4e835.png";